module.exports = __webpack_public_path__ + "img/Wipev-Logo.cfa1f191.png";